import { useEffect } from 'react';

import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import CardApplicationDirectDepositSummaryContainer from '@perpay-web/fintech/components/containers/CardApplicationDirectDepositSummaryContainer';
import SSICardApplicationDirectDepositSummaryContainer from '@perpay-web/fintech/components/containers/SSICardApplicationDirectDepositSummaryContainer';

const CardApplicationDirectDepositSwitcher = ({
    onMount,
    companyName,
    applicationUuid,
}) => {
    useEffect(() => {
        onMount();
    }, [onMount]);

    if (!companyName) {
        return <WarningLoaderCircle />;
    }

    const SSI_COMPANY_NAMES_SET = new Set([
        'Social Security (Benefits)',
        'VA Benefits',
    ]);
    if (SSI_COMPANY_NAMES_SET.has(companyName)) {
        return (
            <SSICardApplicationDirectDepositSummaryContainer
                applicationUuid={applicationUuid}
            />
        );
    }
    return (
        <CardApplicationDirectDepositSummaryContainer
            applicationUuid={applicationUuid}
        />
    );
};

export default CardApplicationDirectDepositSwitcher;
